export const messages = {
  en: {
    printerRule: {
      title: 'Printer Rule Management',
      addTitle: 'Add Printer Rule',
      editTitle: 'Edit Printer Rule',
      deleteTitle: 'Delete Printer Rule',
      ruleName: 'Rule Name',
      ruleNamePlaceholder: 'Please enter rule name',
      ruleNameRequired: 'Rule name is required',
      ruleNameMaxLength: 'Rule name cannot exceed 64 characters',
      remark: 'Remark',
      remarkPlaceholder: 'Please enter remark',
      remarkMaxLength: 'Remark cannot exceed 512 characters',
      state: 'State',
      deleteConfirm: 'Are you sure to delete this printer rule?',
      tab: {
        machine: 'Cloud Printer',
        fees: 'Fee Auto Print',
        repair: 'Repair Auto Print'
      }
    },
    printerRuleMachine: {
      title: 'Printer Machine Management',
      addTitle: 'Add Printer Machine',
      editTitle: 'Edit Printer Machine',
      deleteTitle: 'Delete Printer Machine',
      id: 'ID',
      idPlaceholder: 'Please enter ID',
      machineName: 'Printer Name',
      machineNamePlaceholder: 'Please enter printer name',
      machine: 'Printer',
      machinePlaceholder: 'Please select printer',
      machineRequired: 'Printer is required',
      quantity: 'Quantity',
      quantityPlaceholder: 'Please enter quantity',
      quantityRequired: 'Quantity is required',
      deleteConfirm: 'Are you sure to delete this printer machine?',
      table: {
        id: 'ID',
        machineName: 'Printer Name',
        quantity: 'Quantity'
      }
    },
    printerRuleFees: {
      title: 'Fee Auto Print Management',
      addTitle: 'Add Fee Auto Print',
      deleteTitle: 'Delete Fee Auto Print',
      id: 'ID',
      idPlaceholder: 'Please enter ID',
      feeName: 'Fee Name',
      feeNamePlaceholder: 'Please enter fee name',
      fee: 'Fee',
      feePlaceholder: 'Please select fee',
      feeRequired: 'Fee is required',
      deleteConfirm: 'Are you sure to delete this fee auto print?',
      table: {
        id: 'ID',
        feeName: 'Fee Name'
      }
    },
    printerRuleRepair: {
      title: 'Repair Auto Print Management',
      addTitle: 'Add Repair Auto Print',
      deleteTitle: 'Delete Repair Auto Print',
      id: 'ID',
      idPlaceholder: 'Please enter ID',
      repairType: 'Repair Type',
      repairTypePlaceholder: 'Please enter repair type',
      repairTypeRequired: 'Repair type is required',
      deleteConfirm: 'Are you sure to delete this repair auto print?',
      table: {
        id: 'ID',
        repairType: 'Repair Type'
      }
    }
  },
  zh: {
    printerRule: {
      title: '打印机规则管理',
      addTitle: '添加打印机规则',
      editTitle: '修改打印机规则',
      deleteTitle: '删除打印机规则',
      ruleName: '规则名称',
      ruleNamePlaceholder: '请输入规则名称',
      ruleNameRequired: '规则名称不能为空',
      ruleNameMaxLength: '规则名称不能超过64个字符',
      remark: '备注',
      remarkPlaceholder: '请输入备注',
      remarkMaxLength: '备注不能超过512个字符',
      state: '状态',
      deleteConfirm: '确定删除此打印机规则吗？',
      tab: {
        machine: '云打印机',
        fees: '缴费自动打印',
        repair: '报修自动打印'
      }
    },
    printerRuleMachine: {
      title: '打印机机器管理',
      addTitle: '添加打印机机器',
      editTitle: '修改打印机机器',
      deleteTitle: '删除打印机机器',
      id: '编号',
      idPlaceholder: '请输入编号',
      machineName: '打印机名称',
      machineNamePlaceholder: '请输入打印机名称',
      machine: '打印机',
      machinePlaceholder: '请选择打印机',
      machineRequired: '打印机不能为空',
      quantity: '打印数量',
      quantityPlaceholder: '请输入打印数量',
      quantityRequired: '打印数量不能为空',
      deleteConfirm: '确定删除此打印机机器吗？',
      table: {
        id: '编号',
        machineName: '打印机名称',
        quantity: '打印数量'
      }
    },
    printerRuleFees: {
      title: '缴费自动打印管理',
      addTitle: '添加缴费自动打印',
      deleteTitle: '删除缴费自动打印',
      id: '编号',
      idPlaceholder: '请输入编号',
      feeName: '费用名称',
      feeNamePlaceholder: '请输入费用名称',
      fee: '费用',
      feePlaceholder: '请选择费用',
      feeRequired: '费用不能为空',
      deleteConfirm: '确定删除此缴费自动打印吗？',
      table: {
        id: '编号',
        feeName: '费用名称'
      }
    },
    printerRuleRepair: {
      title: '报修自动打印管理',
      addTitle: '添加报修自动打印',
      deleteTitle: '删除报修自动打印',
      id: '编号',
      idPlaceholder: '请输入编号',
      repairType: '报修类型',
      repairTypePlaceholder: '请输入报修类型',
      repairTypeRequired: '报修类型不能为空',
      deleteConfirm: '确定删除此报修自动打印吗？',
      table: {
        id: '编号',
        repairType: '报修类型'
      }
    }
  }
}